module.exports = __webpack_public_path__ + "assets/scoober-logo-en-6ac7f9.svg";